import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import usePartnerStackIntegration from './hooks/usePartnerStackIntegration';

import { AuthProvider } from './contexts/AuthContext';
//import { JWTProvider } from "./contexts/JWTContext";
//import { Auth0Provider } from "./contexts/Auth0Context";

import routes, { renderRoutes } from './routes';
import { BASENAME } from './config/constant';
import ReactGA from 'react-ga4';
import { CommonProvider } from './contexts/CommonContext';
import { AmazProvider } from './contexts/AmzContext';
import { FkProvider } from './contexts/FkContext';
import { MyntraProvider } from './contexts/MyntraContext';
import { BlinkitProvider } from './contexts/BlinkitContext';
import { BillingProvider } from './contexts/BillingContext';
import { ReportProvider } from './contexts/ReportContext';
import { PayloadProvider } from './contexts/PayloadContext';
import { TargetingProvider } from './contexts/TargetingContext';
import { RankingDashboardProvider } from './contexts/RankingDashboardContext';
import { SmartSearchProvider } from './contexts/SmartSearchContext';
import { DayPartingProvider } from './contexts/DayPartingContext';
import { SnapShotProvider } from './contexts/SnapShotContext';
import { InstaMartProvider } from './contexts/InstamartContext';
import { AmzDspProvider } from './contexts/AmzDspContext';
import { ZeptoProvider } from './contexts/ZeptoContext';
import { BigbasketProvider } from './contexts/BigbasketContext';
import WaitingPageMaintenanceIcon from './assets/icons/WaitingPage-Maintenance';
import logoImage from 'src/assets/images/hector_logo.png';
import { SystemAlertProvider } from 'src/contexts/SystemAlertContext';
import SystemAlertBanner from 'src/components/SystemAlertBanner';
import usePlanExpiryAlert from 'src/hooks/usePlanExpiryAlert';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, [pathname]);

  return null;
}

const APP_MAINTENANCE = false

const App = () => {
  // Initialize PartnerStack integration
  usePartnerStackIntegration();

  const { source: planExpirySource } = usePlanExpiryAlert();
  const alertSources = [planExpirySource];

  if(APP_MAINTENANCE){
    return (
      <div className="auth-wrapper offline d-flex d-flex justify-content-center align-items-center">
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <img src={logoImage} alt="logo" className='hei-60 mb-5' />
          <WaitingPageMaintenanceIcon />
          <p className='f-24 f-w-900 text-dark'> App is under maintenance !!! </p>
          <div className='blue_btn_2 mt-4 f-14 f-w-600' onClick={() => window.location.reload()}>
            Try again
          </div>
        </div>
      </div>
    )
  }

  
  return (
    <React.Fragment>
      <Router basename={BASENAME}>
        <ScrollToTop />
        <AuthProvider>
          <SystemAlertProvider sources={alertSources}>
            <RankingDashboardProvider>
            <BillingProvider>
              <CommonProvider>
                <DayPartingProvider>
                  <SnapShotProvider>
                  <TargetingProvider>
                    <SmartSearchProvider>
                      <ReportProvider>
                        <AmazProvider>
                          <AmzDspProvider>
                            <FkProvider>
                              <InstaMartProvider>
                              <MyntraProvider>
                                <BlinkitProvider>
                                  <PayloadProvider>
                                    <ZeptoProvider>
                                      <BigbasketProvider>
                                        <SystemAlertBanner />
                                        {renderRoutes(routes)}
                                      </BigbasketProvider>
                                    </ZeptoProvider>
                                  </PayloadProvider>
                                </BlinkitProvider>
                              </MyntraProvider>
                              </InstaMartProvider>
                            </FkProvider>
                          </AmzDspProvider>
                        </AmazProvider>
                      </ReportProvider>
                    </SmartSearchProvider>
                  </TargetingProvider>
                  </SnapShotProvider>
                </DayPartingProvider>
              </CommonProvider>
            </BillingProvider>
            </RankingDashboardProvider>
          </SystemAlertProvider>
        </AuthProvider>
      </Router>
    </React.Fragment>
  );
};

export default App;
